export class GroupState {
  public userGroups: any;
  public selectedGroup: any;
  public postData: any;
  public loadSidebarGroup: boolean = false;
}
